window.addEventListener("load",function(){
    $(".collapsible-trigger-new").click(function(){
        let moduleid = $(this).attr("aria-controls")
        let status = $(this).hasClass("is-open")
        console.log($("#"+moduleid));
        console.log(status);
        if (status) {
            $("#"+moduleid).removeClass("is-open")
            $("#"+moduleid).slideUp()
            $(this).removeClass("is-open")
        }else{
            $("#"+moduleid).addClass("is-open")
            $("#"+moduleid).slideDown()
            $(this).addClass("is-open")
        }

    })
   
    $(".show_password").click(function(){
        let type = $(this).parents(".password-wrapper").find("input").attr("type")
        if (type == 'password') {
            $(this).parents(".password-wrapper").find("input").attr("type","text")
            $(this).html("HIDE")
        }else{
            $(this).parents(".password-wrapper").find("input").attr("type","password")
            $(this).html("SHOW")
        }
    })
})

var forms = document.querySelectorAll(".customForm");
forms.forEach(function(form) {
    form.querySelectorAll(".required").forEach(function(input) {
        input.addEventListener("input", function() {
            this.classList.remove("error");
            var label = document.querySelector("label[for='" + this.id + "']");
            if (label) {
                label.classList.remove("error_label");
            }
        });
    });
    form.querySelector("button[type='submit']").addEventListener("click",function(event){
        event.preventDefault(); 
        var formValid = true;
        var inputs = form.querySelectorAll(".required");
        var formId = form.id;
        if (formId =="create_customer") {
            var password = document.getElementById("CreatePassword").value;
            var password2 = document.getElementById("RepeatPassword").value;

            if (password != password2) {
                document.getElementById("RepeatPassword").classList.add("error");
                document.querySelector(".repeatPassword-label").classList.add("error_label");
                document.querySelector(".repeatpassword_tip").style.display = "block";
                formValid = false;
            } else {
                document.getElementById("RepeatPassword").classList.remove("error");
                document.querySelector(".repeatPassword-label").classList.remove("error_label");
                document.querySelector(".repeatpassword_tip").style.display = "none";
            }
        }
        inputs.forEach(function(input) {
            if (input.type === "checkbox" && !input.checked) {
                input.classList.add("error");
                var label = form.querySelector("label[for='" + input.id + "']");
                if (label) {
                    label.classList.add("error_label");
                }
                formValid = false;
            } else if (input.value.trim() === "") {
                input.classList.add("error");
                var label = form.querySelector("label[for='" + input.id + "']");
                if (label) {
                    label.classList.add("error_label");
                }
                formValid = false;
            } else {
                input.classList.remove("error");
                var label = form.querySelector("label[for='" + input.id + "']");
                if (label) {
                    label.classList.remove("error_label");
                }
            }
        });

        // if (!formValid) {
        //     event.preventDefault(); 
        // }
    })
    
});
